/** @format */

import React from 'react';
import { Dot, LoaderWrapper } from './Loader.style';

const Loader: React.FC = () => {
  return (
    <LoaderWrapper>
      <Dot $delay={0} />
      <Dot $delay={0.1} />
      <Dot $delay={0.3} />
    </LoaderWrapper>
  );
};

export { Loader };
